var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.356079,
    width: 37.3936,
    height: 38.1609,
    rx: 8.18462,
    fill: "#142240"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7326 24.4366H11.1968V20.9007L20.7259 11.3716C20.8822 11.2153 21.0941 11.1276 21.3151 11.1276C21.5361 11.1276 21.748 11.2153 21.9043 11.3716L24.2618 13.7291C24.418 13.8853 24.5058 14.0972 24.5058 14.3182C24.5058 14.5392 24.418 14.7511 24.2618 14.9074L14.7326 24.4366ZM11.1968 26.1032H26.1968V27.7699H11.1968V26.1032Z",
    fill: "#56CCF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8.69678 9.43652)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.336e2b7cef821abcc44701428910cc0b.svg";
export { ForwardRef as ReactComponent };